@for (article of zendeskHelpCenterArticles(); track article.id) {
  <mp-zendesk-help-center-article-card
    class="help-center-article"
    [articleTitle]="article.title"
    [articleHTMLDescription]="article.body"
    [articleLink]="article.htmlUrl"
  />
}
